import Drift from "@components/marketing-scripts/driftt"
import StructuredData from "@components/marketing-scripts/structured-data"
import Swiftype from "@components/marketing-scripts/swiftype"
import MunchkinScript from "@components/marketing-scripts/munchkin"
import OneTrust from "@components/marketing-scripts/onetrust"
import SpeedCurve from "@components/marketing-scripts/speedcurve"
import Intellimize from "./marketing-scripts/intellimize"

// Not really ALL the scripts anymore. The OneTrust (cookie banner) script
// has been moved to gatsby-browser.
const AllTheScripts = () => (
  <>
    <Intellimize />
    <SpeedCurve />
    <MunchkinScript />
    <OneTrust />
    <Drift />
    <StructuredData />
    <Swiftype />
    <script>{`performance.mark("scripts done blocking");`}</script>
  </>
)

export default AllTheScripts
